"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.corsHeaders = void 0;
const ALLOWED_ORIGINS = [
    'https://dev-ledgiventa.aws.akfdev.com',
    'https://ledgiventa.aws.akfdev.com',
    'http://localhost:3000',
];
function corsHeaders(requestOrigin) {
    const origin = requestOrigin && ALLOWED_ORIGINS.includes(requestOrigin)
        ? requestOrigin
        : ALLOWED_ORIGINS[0];
    return {
        'Access-Control-Allow-Origin': origin,
        'Access-Control-Allow-Headers': 'Content-Type,Authorization,X-Amz-Date,X-Api-Key,X-Amz-Security-Token,X-Clerk-Subdomain',
        'Access-Control-Allow-Methods': 'OPTIONS,GET,POST,PUT,DELETE',
        'Content-Type': 'application/json',
    };
}
exports.corsHeaders = corsHeaders;
